<template>
	<div>
		<router-view name="newPresentForm"></router-view>
		<div class="wrapper-presents"
			:style="`border-color:${$appColors.gray}`"
		>
			<presents-list
				:columns="columns"
				:rows="presents"/>
			<div class="buttons-container" v-if="presents.length === 0 && $route.name === 'award'">
				<app-button
					class="btn-tool"
					text="Nuevo"
					icon="add"
					:style="`background-color:${$appColors.primary}`"
					@click="newPresentForm('new-present')"
				></app-button>
			</div>
		</div>
	</div>
</template>
<script>
import { getPropertysValue } from 'functionallibrary';
import appButton from '@/components/shared/app-button';
import presentsList from '@/components/configuration/presents/presents-list';
import { mapState } from 'vuex';

function emptyRows() {
	return this.rows.length === 0;
}

function newPresentForm(name) {
	this.goTo(name);
}

async function created() {
	await this.$store.dispatch('presentsConfiguration/loadAllPresents');
}

function getIcon(present) {
	return getPropertysValue('icon.urlImage.movil')(present);
}

function editPresent() {}

function deletePresent() {}

function data() {
	return {
		columns: [
			{
				id: 1,
				name: 'NOMBRE',
				value: 'name',
				visible: true,
			},
			{
				id: 2,
				name: 'ICONO',
				value: 'icon',
				visible: true,
			},
			{
				id: 3,
				name: 'PUNTOS',
				value: 'points',
				visible: true,
			},
			{
				id: 4,
				name: 'ACCIONES',
				value: 'actions',
				visible: true,
				flagVisible: true,
			},
		],
	};
}
export default {
	name: 'presents',
	data,
	components: {
		appButton,
		presentsList,
	},
	computed: {
		...mapState('presentsConfiguration', {
			presents: state => state.presents,
		}),
		emptyRows,
	},
	created,
	methods: {
		editPresent,
		deletePresent,
		getIcon,
		newPresentForm,
	},
};
</script>
<style lang="scss" scoped>
	.wrapper-presents {
		background-color: white;
		border: 1px solid;
		box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
		@media (max-width: 950px) {
			width: 700px;
		}
		table.table-list {
			border: none;
			box-shadow: none;
		}

		.buttons-container {
			align-items: center;
			height: 200px;
			display: flex;
			justify-content: center;

			.btn-tool {
				border-radius: 4px;
				color: white;
				font-family: font(bold);
				margin: 0 10px;
				padding: 5px 10px;
			}
		}
	}

	.border-top {
		text-align: center !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-config-presents.vue